<script lang="ts" setup>
  const { isDesktop } = useBreakpoints()

  const props = defineProps<{
    heroImage: any
    heroCard?: any
  }>()

  const imageWidth = computed(() => {
    return isDesktop.value ? 1600 : 320
  })

  const imageHeight = computed(() => {
    return isDesktop.value ? 480 : 420
  })
</script>

<template>
  <div class="relative mb-8 lg:mb-10">
    <NuxtImg
      :alt="props.heroImage.alt ?? ''"
      :title="props.heroImage.title ?? ''"
      :height="imageHeight"
      :src="props.heroImage.filename"
      :width="imageWidth"
      format="webp"
      preload
      class="size-full max-h-105 object-cover md:max-h-120"
    />
    <div v-if="props.heroCard.length">
      <div
        class="absolute inset-y-0 right-0 m-auto flex max-h-120 w-full max-w-280 items-center justify-center px-4 lg:left-0 xl:!px-0 [&>*]:!mb-0"
      >
        <StoryblokComponent :blok="props.heroCard[0]" />
      </div>
    </div>
  </div>
</template>
